import { useController } from 'react-hook-form'

/**
 * FormTextArea Logic Hook
 * Handles React Hook Form integration for textarea fields
 *
 * @param {Object} props
 * @param {string} props.name - Field name for RHF
 * @param {Object} props.control - RHF control object
 * @param {string} [props.defaultValue=''] - Default value
 * @param {Object} [props.rules] - RHF validation rules
 * @returns {Object} Field state and handlers
 */
export function useFormTextArea({ name, control, defaultValue = '', rules }) {
  const {
    field,
    fieldState: { error, invalid },
  } = useController({
    name,
    control,
    defaultValue,
    rules,
  })

  return {
    // Field props from RHF
    value: field.value,
    onChange: (e, { value }) => field.onChange(value), // Adapt Semantic UI event shape
    onBlur: field.onBlur,
    name: field.name,
    ref: field.ref,

    // Validation state
    error: invalid,
    errorMessage: error?.message,
  }
}
